import { prepareHeaders } from 'api/inc-api-headers';
import { ServerUrl } from 'filepond';
import { getStore } from 'redux/store';
import { getClientId } from 'util/client-id';
import { getEnv } from 'util/getEnv';

export const urlToType = url => {
  const ext = url.split('.').pop();
  switch (ext) {
    case 'png':
      return 'image/png';
    case 'gif':
      return 'image/gif';
    case 'jpg':
    case 'jpeg':
    default:
      return 'image/jpeg';
  }
};

export const urlToFilepondFile = url => ({
  source: url,
  options: {
    type: 'local',
  },
});

export type ObjectType =
  | 'CATALOG'
  | 'GROUP'
  | 'ITEM'
  | 'MESSAGE'
  | 'OFFER'
  | 'CATEGORY'
  | 'PERSONA'
  | 'STORE'
  | 'BRAND'
  | 'PROFILE'
  | 'PROMOCODE';

export const mediaUploadProcess = (
  name: string,
  objectType: ObjectType,
): ServerUrl => {
  return {
    url: `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/incentivio-media/clients/${getClientId()}/media?source=s3`,
    method: 'POST' as const,
    headers: Object.fromEntries(
      prepareHeaders(new Headers(), {
        getState: getStore().getState,
      }) as Headers,
    ),
    onload: response => {
      const parsed = JSON.parse(response);
      return parsed.downloadUrl;
    },
    ondata: formData => {
      formData.append('object-type', objectType);

      if (['OFFER', 'MESSAGE'].includes(objectType)) {
        formData.append('object-id', window.crypto.randomUUID());
        formData.append('Content-Type', 'false');
        formData.set('file', formData.getAll(name)[1]);
        formData.delete(name);
      } else {
        const allFile = formData.getAll(name);
        allFile.forEach(value => formData.append('file', value));
      }
      return formData;
    },
  };
};

export const defaultLoad =
  (getId: (file: any) => string, init?: RequestInit) =>
  (source, load, error, _progress, abort) => {
    fetch(getId(source), init)
      .then(async res => {
        if (!res.ok) {
          error(JSON.stringify(res));
          return;
        }
        const blob = await res.blob();
        load(new Blob([blob], { type: urlToType(source) }));
      })
      .catch(e => error(e));

    return {
      abort,
    };
  };

export const FILE_UPLOADING_STATUS = 'UPLOADING';

export const sanitizeUploadingValues = (obj: unknown): unknown => {
  if (obj === FILE_UPLOADING_STATUS) return '';
  if (Array.isArray(obj)) {
    return obj
      .filter(
        item =>
          !(
            item &&
            typeof item === 'object' &&
            !Array.isArray(item) &&
            (item as Record<string, unknown>).status === FILE_UPLOADING_STATUS
          ),
      )
      .map(sanitizeUploadingValues);
  }
  if (obj && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj).map(([k, v]) => [k, sanitizeUploadingValues(v)]),
    );
  }
  return obj;
};
